import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-web-navbar',
  templateUrl: './web-navbar.component.html',
  styleUrl: './web-navbar.component.scss'
})
export class WebNavbarComponent {
  showQrModal = false;
  showSearch = false;
  searchQuery = '';

  @Output() searchProducts = new EventEmitter<string>();

  openQrModal() {
    this.showQrModal = true;
  }

  closeQrModal() {
    this.showQrModal = false;
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
    if (!this.showSearch) {
      this.searchQuery = '';
      this.searchProducts.emit('');
    } else {
      setTimeout(() => {
        const input = document.getElementById('navbar-search-input');
        if (input) input.focus();
      }, 100);
    }
  }

  onSearchInput() {
    this.searchProducts.emit(this.searchQuery.trim());
  }

  clearSearch() {
    this.searchQuery = '';
    this.searchProducts.emit('');
  }
}
